import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'
import { Card } from 'ui-components/Card'
import { DescItemInfo } from 'ui-components/DescItemInfo'
import { Button } from 'ui-components/Button'
import { Confirm } from 'ui-components/Confirm'
import { PrintPaymentButton } from 'components/PrintPaymentButton'

import { Item, Total, Buttons } from './styles'

export default function PaymentInfo({ payment, onCancel }) {
  const [showConfirm, setShowConfirm] = useState(false)

  const cancelConfirmation = () => {
    setShowConfirm(false)
    onCancel()
  }

  const renderCancelConfirmation = () => (
    <Confirm
      open={showConfirm}
      title="Cancelar pagamento"
      onCancel={() => setShowConfirm(false)}
      onConfirm={cancelConfirmation}
      confirmButtonText="Sim"
      cancelButtonText="Não"
      type="warning"
    >
      <div>
        Deseja realmente cancelar este pagamento?
      </div>
      <div>
        Esta ação não poderá ser desfeita.
      </div>
    </Confirm>
  )

  const renderPaymentItem = (item) => (
    <Item key={`payment-item-${item.id}`}>
      <DescItemInfo label="Número">
        { item.code }
      </DescItemInfo>
      <DescItemInfo label="Tipo">
        { item.description }
      </DescItemInfo>
      <DescItemInfo label="R$ Valor">
        { currencyFormat(item.value) }
      </DescItemInfo>
    </Item>
  )

  const renderPaymentMethod = (item) => (
    <Item key={`payment-method-${item.id}`}>
      <DescItemInfo label="Número">
        { item.code }
      </DescItemInfo>
      <DescItemInfo label="Tipo">
        { item.description }
      </DescItemInfo>
      <DescItemInfo label="R$ Valor">
        { currencyFormat(item.value) }
      </DescItemInfo>
    </Item>
  )

  const renderTotal = (total, label = 'TOTAL') => (
    <Total>
      <strong>{label}</strong>

      <strong>
        { `R$ ${currencyFormat(total)}` }
      </strong>
    </Total>
  )

  const renderGeneratedDebt = () => (
    <div>
      <h5>Débito gerado</h5>
      <Item key={`payment-generated-debt-${payment.generated_debt.id}`}>
        <DescItemInfo label="Número">
          { payment.generated_debt.code }
        </DescItemInfo>
        <DescItemInfo label="Tipo">
          Débito
        </DescItemInfo>
        <DescItemInfo label="R$ Valor">
          { currencyFormat(payment.generated_debt.valuej) }
        </DescItemInfo>
      </Item>
    </div>
  )

  const renderGeneratedVoucher = () => (
    <div>
      <h5>Voucher gerado</h5>
      <Item key={`payment-generated-voucher-${payment.generated_voucher.id}`}>
        <DescItemInfo label="Número">
          { payment.generated_voucher.code }
        </DescItemInfo>
        <DescItemInfo label="Tipo">
          Voucher
        </DescItemInfo>
        <DescItemInfo label="R$ Valor">
          { currencyFormat(payment.generated_voucher.value) }
        </DescItemInfo>
      </Item>
    </div>
  )

  return !payment ? null : (
    <Card>
      {renderCancelConfirmation()}
      <h4>{ `Pagamento nº ${payment.code}` }</h4>

      <div>
        <h5>Itens pagos</h5>
        {payment.payment_items.map(renderPaymentItem)}
      </div>

      <div>
        <h5>Formas de pagamento</h5>
        {payment.payment_methods.map(renderPaymentMethod)}
      </div>
      {payment.generated_debt ? renderGeneratedDebt() : null}
      {payment.generated_voucher ? renderGeneratedVoucher() : null}

      <div>
        <br />
        {renderTotal(payment.total_to_pay)}
        {renderTotal(payment.total_paid, 'PAGO')}
        {renderTotal(payment.change_value, 'TROCO')}
      </div>

      <Buttons>
        <Button
          color="secondary"
          onClick={() => setShowConfirm(true)}
        >
          Cancelar Pagamento
        </Button>

        <PrintPaymentButton paymentId={payment.id} />
      </Buttons>
    </Card>
  )
}

PaymentInfo.propTypes = {
  payment: PropTypes.objectOf(PropTypes.any),
  onCancel: PropTypes.func.isRequired,
}

PaymentInfo.defaultProps = {
  payment: null,
}
